import React, { useContext } from 'react';

import moment from 'moment';
import 'moment/locale/fi';
import 'moment/locale/en-gb';
import LocaleContext from 'constants/localization';

export default function DateDisplay({value}) {
  const LS = useContext(LocaleContext);
  moment.locale(LS.getLanguage());
  return <span>{moment(new Date(value)).format('LL')}</span> ;
}